import { Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import { useTranslation } from 'react-i18next';

import { ActionButton, Card } from '~components';
import LastOnline from '~components/data/lastOnline';
import RasterImage from '~components/media/rasterImage';
import Device from '~interfaces/device';
import { Dimens } from '~themes';

interface Props {
	device: Device;
	onViewDevice: () => void;
}

const WallReaderCard = ({ device, onViewDevice }: Props) => {
	const { t } = useTranslation();

	return (
		<Card density='dense'>
			<Stack
				direction='row'
				spacing={Dimens.spacingXl}
				alignItems='center'
				sx={{
					paddingX: Dimens.spacingMd,
				}}
			>
				<Box
					sx={{
						height: '56px',
						width: '56px',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					<RasterImage name='device/model/skdoel-03' size='100%' />
				</Box>
				<Stack sx={{ flexGrow: 1 }}>
					<Typography variant='label'>{`${device.name} (${device.hardwareId})`}</Typography>
					<LastOnline date={device?.state?.lastReport} />
				</Stack>
				<ActionButton label={t('viewDevice', { ns: 'actions' })} onClick={onViewDevice} />
			</Stack>
		</Card>
	);
};

export default WallReaderCard;
